// @ts-nocheck
import action from 'utils/actionCreators';

export const GET_ALL_ROLES_REQUEST = 'GET_ALL_ROLES_REQUEST';
export const GET_ALL_ROLES_SUCCESS = 'GET_ALL_ROLES_SUCCESS';
export const GET_ALL_ROLES_FAILURE = 'GET_ALL_ROLES_FAILURE';

export const ADD_NEW_ROLES_REQUEST = 'ADD_NEW_ROLES_REQUEST';
export const ADD_NEW_ROLES_SUCCESS = 'ADD_NEW_ROLES_SUCCESS';
export const ADD_NEW_ROLES_FAILURE = 'ADD_NEW_ROLES_FAILURE';

export const GET_ALL_PERMISSIONS_REQUEST = 'GET_ALL_PERMISSIONS_REQUEST';
export const GET_ALL_PERMISSIONS_SUCCESS = 'GET_ALL_PERMISSIONS_SUCCESS';
export const GET_ALL_PERMISSIONS_FAILURE = 'GET_ALL_PERMISSIONS_FAILURE';

export const GET_ROLE_BY_ID_REQUEST = 'GET_ROLE_BY_ID_REQUEST';
export const GET_ROLE_BY_ID_SUCCESS = 'GET_ROLE_BY_ID_SUCCESS';
export const GET_ROLE_BY_ID_FAILURE = 'GET_ROLE_BY_ID_FAILURE';

export const GET_PERMISSIONS_BY_ROLE_ID_REQUEST =
  'GET_PERMISSIONS_BY_ROLE_ID_REQUEST';
export const GET_PERMISSIONS_BY_ROLE_ID_SUCCESS =
  'GET_PERMISSIONS_BY_ROLE_ID_SUCCESS';
export const GET_PERMISSIONS_BY_ROLE_ID_FAILURE =
  'GET_PERMISSIONS_BY_ROLE_ID_FAILURE';

export const UPDATE_ROLE_BY_ID_REQUEST = 'UPDATE_ROLE_BY_ID_REQUEST';

export const UPDATE_ROLE_BY_ID_SUCCESS = 'UPDATE_ROLE_BY_ID_SUCCESS';

export const UPDATE_ROLE_BY_ID_FAILURE = 'UPDATE_ROLE_BY_ID_FAILURE';

export const getAllRolesRequest = action(GET_ALL_ROLES_REQUEST);
export const getAllRolesSuccess = action(GET_ALL_ROLES_SUCCESS);
export const getAllRolesFailure = action(GET_ALL_ROLES_FAILURE);

export const addNewRolesRequest = action(ADD_NEW_ROLES_REQUEST, 'payload');
export const addNewRolesSuccess = action(ADD_NEW_ROLES_SUCCESS);
export const addNewRolesFailure = action(ADD_NEW_ROLES_FAILURE);

export const getAllPermissionsRequest = action(
  GET_ALL_PERMISSIONS_REQUEST,
  'payload',
);
export const getAllPermissionsSuccess = action(
  GET_ALL_PERMISSIONS_SUCCESS,
  'payload',
);
export const getAllPermissionsFailure = action(GET_ALL_PERMISSIONS_FAILURE);

export const getRoleByIdRequest = action(GET_ROLE_BY_ID_REQUEST, 'id');

export const getPermissionsByRoleIdRequest = action(
  GET_PERMISSIONS_BY_ROLE_ID_REQUEST,
  'id',
);
export const getPermissionsByRoleIdSuccess = action(
  GET_PERMISSIONS_BY_ROLE_ID_SUCCESS,
);
export const getPermissionsByRoleIdFailure = action(
  GET_PERMISSIONS_BY_ROLE_ID_FAILURE,
);

export const updateRoleByIdRequest = action(
  UPDATE_ROLE_BY_ID_REQUEST,
  'id',
  'payload',
);
export const updateRoleByIdSuccess = action(
  UPDATE_ROLE_BY_ID_SUCCESS,
  'id',
  'payload',
);
export const updateRoleByIdFailure = action(UPDATE_ROLE_BY_ID_FAILURE);
